<app-floorplan-product-menu
  [title]="tooltipTextTransmitters"
  [hasConfigurations]="transmitters.length > 0"
  [visible]="floorplan.floorplanState.transmittersVisible"
  [locked]="floorplan.floorplanState.transmittersLocked"
  [itemTextVisible]="floorplan.floorplanState.transmittersItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.transmittersVisible = $event"
  (lockUpdate)="floorplan.floorplanState.transmittersLocked = $event"
  (itemTextVisibilityUpdate)="updateTransmittersItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="transmitter"
>
  <button
    additionalButton
    odxButton
    variant="secondary"
    (click)="toggleMonitoringAreaVisibility()"
    [odxTooltip]="floorplan.floorplanState.monitoringAreasVisible ? tooltipTextHideMonitoringArea : tooltipTextShowMonitoringArea"
    [odxTooltipOptions]="{ position: 'bottom' }"
  >
    <img
      alt="Überwachungsbereich ein-/ausblenden"
      class="odx-icon"
      [src]="
        floorplan.floorplanState.monitoringAreasVisible
          ? '../../../../assets/floorplan-menu-icons/ueberwachungsbereich_on_nicht_odx.svg'
          : '../../../../assets/floorplan-menu-icons/ueberwachungsbereich_off.svg'
      "
    />
  </button>

  @for (transmitterSubtitle of transmitterSubtitles | keyvalue; track transmitterSubtitle) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="transmitterSubtitle.key"
        [numberOfFloorplanItems]="floorplan.countPlacedTransmitters(transmitterSubtitle.key)"
        [attachments]="transmitterSubtitle.key.attachments"
        [subtitlePrefix]="(transmitterSubtitle.value | async)?.subtitle ?? ''"
        [substanceSubtitle]="(transmitterSubtitle.value | async)?.substanceSubtitle ?? ''"
        (add)="addTransmitter(transmitterSubtitle.key)"
        (delete)="deleteTransmitter(transmitterSubtitle.key)"
        (dragStart)="drag(transmitterSubtitle.key)"
        editPath="transmitter"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
